/**
 * @file
 * Input device properties.
 */


const userAgent = navigator.userAgent;
const winPhone = /IEMobile/.test(userAgent);
const iosTouch = !winPhone && /iP(hone|ad|od)\;/.test(userAgent);
const iPadPro = navigator.platform == 'MacIntel' && navigator.maxTouchPoints == 5;
const mac = /^Mac/.test(navigator.platform);
const otherMobile = !winPhone && !iosTouch && !iPadPro && /Android|(Mobile|Tablet)[;/]/.test(userAgent);


const $device = Vue.observable(/** @alias $device */ {
    /** @member {boolean} - `true` if this is a device that can be relied on to have a hardware keyboard; this is nonreactive. */
    keyboard: !(winPhone || iosTouch || iPadPro || otherMobile),

    /** @member {boolean} - `true` if the primary pointing device is a mouse. This is potentially reactive on newer devices. */
    mouse: false,

    /** @member {boolean} - `true` if this is an iOS device; used to deal with iOS issues. */
    ios: iosTouch || iPadPro,

    /** @member {boolean} - `true` if this is a Mac; used to deal with Cmd vs Ctrl key issues. */
    mac,

    /** @ignore - DEPRECATED */
    mobile: $build.platform == 'android' ? true
          : $build.platform == 'ios' ? true
          : $build.platform == 'desktop' ? false
          : winPhone || iosTouch || otherMobile
});


const pointerFine = matchMedia('(pointer:fine)');
const pointerCoarse = matchMedia('(pointer:coarse)');

function pointerChange() {
    /** @ignore */
    $device.mouse = pointerFine.matches || pointerCoarse.matches ? pointerFine.matches : !(winPhone || iosTouch || iPadPro || otherMobile);
}
pointerChange();
try {
    pointerFine.addEventListener('change', pointerChange);
} catch (e) {
    pointerFine.addListener(pointerChange);
}


export default $device;
